import { useState, useEffect } from 'react';

// Hook
const useWindowSize = () => {
  const isClient = typeof window === 'object';

  if (!isClient) {
    return {
      width: undefined,
      height: undefined
    };
  }

  function getSize() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
};

export default useWindowSize;
